<template>
  <!-- 签约活动 -->
  <div>
    <Form ref="form" :model="formData" :label-width="100" class="page-form">
      <FormItem prop="type" label="活动类型" :rules="$units.formRule.required('请选择')" class="half" label-position="left">
        <RadioGroup v-model="formData.type" @on-change="changeType">
          <Radio label="1" :disabled="formData.status == '1' || formData.status == '-1'">增员活动（直接推荐人）</Radio>
          <Radio label="2" :disabled="formData.status == '1' || formData.status == '-1'">出单活动（业务员）</Radio>
          <Radio label="3" :disabled="formData.status == '1' || formData.status == '-1'">签约活动</Radio>
          <Radio label="4" :disabled="formData.status == '1' || formData.status == '-1'" v-if="$units.isOkBao()">报名活动</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem prop="mode" label="活动方式" :rules="$units.formRule.required('请选择活动方式')" class="half" key="mode2">
        <template #label>
          <span>
            活动方式
            <Tooltip transfer max-width="1000">
              <Icon type="md-help-circle" style="color: #a8adb7" size="16" />
              <template #content>
                <p>梯度：活动有指标，需设置区间，达到对应条件才能获奖</p>
              </template>
            </Tooltip>
          </span>
        </template>
        <RadioGroup v-model="formData.mode">
          <Radio label="2" :disabled="formData.status == '1' || formData.status == '-1'">梯度</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem
        prop="rewardType"
        label="奖励类型"
        :rules="$units.formRule.arrRequired('请选择奖励类型', (trigger = 'change'))"
        v-if="formData.mode == 2"
        class="half"
      > 
        <CheckboxGroup v-model="formData.rewardType" @on-change='changeRewardType'>
          <Checkbox value="2" label="2" :disabled="formData.status == '1' || formData.status == '-1'">实物</Checkbox>
          <Checkbox value="3" label="3" :disabled="formData.status == '1' || formData.status == '-1'">现金</Checkbox>
        </CheckboxGroup>
      </FormItem>
    </Form>
    <div class="tip" v-if="formData.mode == 2">
      <p class="title">配置说明：</p>
      <p>1、最大值和最小值都是包含当前数字，最大值可等于最小值；2、最后一条数据，条件指标最大值可以不填，最后结果为 最小值及以上</p>
    </div>
    <div class="table-box" v-if="formData.mode == 2">
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row, index }" slot="action" v-if="formData.status != '1' && formData.status != '-1'">
          <div class="detail">
            <div v-if="!row.isEdit" @click="row.isEdit = true">编辑</div>
            <div @click="delTable(index)">删除</div>
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="rewardSelect">
          <Select v-model="gradientConfigs[index].rewardSelect" transfer placeholder="请选择奖励类型" clearable :disabled="!row.isEdit" @on-change='changeRewardSelect($event, gradientConfigs[index])'>
            <Option value="kindReward" :disabled="!formData.rewardType.includes('2')">实物</Option>
            <Option value="cashReward" :disabled="!formData.rewardType.includes('3')">现金</Option>
          </Select>
        </template>
        <template slot-scope="{ row, column, index }" slot="input">
          <div v-if="[3, 6].includes(formData.conditionalIndicator*1)">
            <Input
              v-model="gradientConfigs[index][column.key]"
              :type="formData.rewardType != 2 && column.title == '奖励' ? 'number' : 'text'"
              placeholder="请输入"
              v-if="row.isEdit"
            />
            <div v-else>
              <span>{{ gradientConfigs[index][column.key] }}</span>
            </div>
          </div>

          <div v-else>
            <Input
              v-model="gradientConfigs[index][column.key]"
              :type="gradientConfigs[index].rewardSelect == 'cashReward' ? 'number' : 'text'"
              placeholder="请输入"
              v-if="row.isEdit"
            />
            <div v-else>
              <span>{{ gradientConfigs[index][column.key] }}</span>
            </div>
          </div>
        </template>
      </Table>

      <div class="btn-item" style="margin-top: 10px">
        <Button type="warning" @click="addTable" :disabled="formData.status == '1' || formData.status == '-1'">新增</Button>
      </div>
    </div>
  </div>
</template>

<script>
import { pageTool } from '@/api/mixins';
import _ from 'lodash';
export default {
  props: ['tableList', 'activityType', 'id', 'compontntType'],
  mixins: [pageTool],
  data() {
    return {
      formData: {
        type: '2',
        mode: '2',
        rewardType: [],
        calFactor: '2',
        productType: '1',
        conditionalIndicator: '2',
        needSignup: '0',
        calculateType: '0'
      },
      tableData: [],
      gradientConfigs: [],
      isSupportFirstPolicy: sessionStorage.getItem('isSupportFirstPolicy'),
      columns: [
        {
          title: '条件指标最小值',
          key: 'minValue',
          key2: 'minValue',
          align: 'center',
          slot: 'input'
        },
        {
          title: '条件指标最大值',
          key: 'maxValue',
          key2: 'maxValue',
          align: 'center',
          slot: 'input'
        },
        {
          title: '奖励类型',
          key: 'rewardSelect',
          align: 'center',
          slot: 'rewardSelect'
        },
        {
          title: '奖励',
          key: 'value',
          key2: 'value',
          align: 'center',
          slot: 'input',
          width: '200'
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center'
        }
      ]
    };
  },
  methods: {
    // 修改活动类型
    changeType(value) {
      const formData = JSON.parse(JSON.stringify(this.formData));
      if (formData.type == 1) {
        formData.rewardType = '1';
      } else if(formData.type == 2) {
        formData.mode = '1';
        formData.rewardType = [];
      } else if(formData.type == 3) {
        formData.mode = '2';
        formData.rewardType = [];
      }
      this.$emit('typeChange', formData);
      this.$bus.$emit('resetList', formData);
    },


    // 改变奖励类型
    changeRewardType(value) {
      if(!value.length || value.length==1) {
        let gradientConfigs = JSON.parse(JSON.stringify(this.gradientConfigs));
        gradientConfigs.forEach(item=>{
          delete item.cashReward;
          delete item.kindReward;
          delete item.rewardSelect;
          delete item.value;
        })
        this.$set(this, 'gradientConfigs', gradientConfigs);
      }
    },
    getTableData() {
      if (this.id && this.formData.type == 3) {
        this.$http({
          url: '/buz/merchantActivity/queryGradientConfig',
          type: 'get',
          data: {
            id: this.id
          }
        }).then(res => {
          this.tableData = res.data.map(item => {
            item.maxValue = item.maxValue?Number(item.maxValue):null;
            item.minValue = Number(item.minValue);
            // 加佣
            if(this.formData.rewardType==3){
              // 现金
              item.value  =  Number(item.cashReward);
              item.rewardSelect = 'cashReward';
            }else {
              // 实物
              item.value = item.kindReward;
              item.rewardSelect = 'kindReward';
            }
            return {
              ...item,
              isEdit: false
            };
          });
          this.gradientConfigs = res.data;
        });
      }
    },
    addTable() {
      this.tableData.push({
        isEdit: true
      });
      let data = {
        minValue: null,
        maxValue: null,  
        rateReward: null,
        cashReward: null,
      }
      this.gradientConfigs.push(data);
    },
    delTable(index) {
      this.tableData.splice(index, 1);
      this.gradientConfigs.splice(index, 1);
    },
    validate() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate(valid => {
          if (valid) {
            try {
              if (this.formData.mode == 2 && !this.gradientConfigs.length) {
                this.$Message.error('请配置梯度活动奖励');
                return;
              }
              this.gradientConfigs.map((item, index) => {
                if ((!item.minValue && item.minValue != 0)  || (!item.value && item.value != 0)) {
                  this.$notice.error(`请完善第${index + 1}行表格内容`);
                  throw new Error();
                } else if (item.maxValue && Number(item.minValue) > Number(item.maxValue)) {
                  this.$notice.error(`第${index + 1}行中，最小值需小于最大值`);
                  throw new Error();
                }
              });
              const formData = JSON.parse(JSON.stringify(this.formData));
              formData.rewardType = formData.rewardType.join(',');
              resolve(formData);
            } catch (error) {
              reject();
              console.log(error);
            }
          } else {
            reject();
          }
        });
      });
    },
    // 回显信息
    setData(data) {
      this.formData = {
        status: data.status,
        type: String(data.type),
        mode: String(data.mode),
        joinType: String(data.joinType ? data.joinType : ''),
        rewardType: data.rewardType ? data.rewardType.split(',') : [],
        calFactor: String(data.calFactor ? data.calFactor : ''),
        conditionalIndicator: String(data.conditionalIndicator ? data.conditionalIndicator : ''),
        productType: String(data.productType ? data.productType : ''),
        endorsementIsJoin: String(data.endorsementIsJoin == '0 ' || data.endorsementIsJoin == 1 ? data.endorsementIsJoin : ''),
        needSignup: String(data.needSignup == '0' || data.needSignup == '1' ? data.needSignup + '' : ''),
        calculateType: data.calculateType == '0' || data.calculateType == '1' ? data.calculateType + '' : ''
      };
      if (this.compontntType == 'addModal') {
        this.changeRewardType(data.rewardType);
      }
      this.getTableData();
    },
    // 修改奖励类型
    changeRewardSelect(value, item) {
      if(value=='kindReward') {
        // 选择实物删除现金字段
        delete item.cashReward
      }else{
        // 选择现金删除实物字段
        delete item.kindReward;
      }
    },
    // 删除表单字段
    delFormData(key) {
      delete this.formData[key];
    }
  },
  watch: {
    tableList: {
      handler() {
        console.log('watch.tableList', this.tableList)
        if (this.compontntType != 'configModal') {
          this.tableList.map(item => {
            if (item.kindReward) {
              item.rewardSelect = 'kindReward';
              item.value = item.kindReward;
            } else {
              item.rewardSelect = 'cashReward';
              item.value = item.cashReward;
            }
          });
        }
        this.tableData = _.cloneDeep(this.tableList);
        this.gradientConfigs = _.cloneDeep(this.tableList);
      },
      immediate: true
    },
    activityType(newVal) {
      this.formData.type = newVal;
    }
  }
};
</script>
<style lang="scss" scoped>
.tip {
  display: flex;
  align-items: center;
  height: 40px;
  height: 40px;
  padding-left: 20px;
  background: #f7faff;
  border-radius: 4px;
  .title {
    font-weight: bold;
  }
  p {
    color: #3f6ec9;
    font-size: 12px;
  }
}
.btn-item {
  margin-bottom: 30px;
  display: flex;
}
/deep/ .ivu-radio-group-item {
  margin-right: 20px !important;
}
/deep/ .ivu-checkbox-group-item {
  margin-right: 20px !important;
}
</style>
